const TOTAL_CLASS_PARTICIPANTS = 'Total Class Participants: ';
const TOTAL_POLL_PARTICIPANTS = 'Total Poll Participants: ';

const POLL_TYPE_LABELS = {
  poll: 'Poll',
  quiz: 'Quiz'
};

const DESCRIPTION_LABEL = 'Participant responses are below.';
const QUES_TYPE = 'single';

const POLL_QUESTION_TYPE_LABELS = {
  single: 'Single choice',
  multiple: 'Multiple choice',
  matching: 'Matching',
  rank_order: 'Rank order',
  short_answer: 'Short answer',
  long_answer: 'Long answer',
  fill_in_the_blank: 'Fill in the blank',
  rating_scale: 'Rating scale'
};

const ZOOM_POLL_DETAIL_QUESTION_TYPE = {
  single: 'single',
  multiple: 'multiple',
  matching: 'matching',
  rank_order: 'rank_order',
  short_answer: 'short_answer',
  long_answer: 'long_answer',
  fill_in_the_blank: 'fill_in_the_blank',
  rating_scale: 'rating_scale'
};

const POLL_REPORT_DOWNLOAD_BTN_CLASS = 'vve-download-btn';
const POLL_REPORT_DOWNLOAD_BTN_ICON_CLASS = 'vve-download-icon';

export {
  TOTAL_CLASS_PARTICIPANTS,
  TOTAL_POLL_PARTICIPANTS,
  POLL_TYPE_LABELS,
  DESCRIPTION_LABEL,
  POLL_QUESTION_TYPE_LABELS,
  QUES_TYPE,
  ZOOM_POLL_DETAIL_QUESTION_TYPE,
  POLL_REPORT_DOWNLOAD_BTN_CLASS,
  POLL_REPORT_DOWNLOAD_BTN_ICON_CLASS
};
